import { render, staticRenderFns } from "./VueDropzonePopup.vue?vue&type=template&id=328cb5ff&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./VueDropzonePopup.vue?vue&type=script&lang=js"
export * from "./VueDropzonePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports